class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function () {
      $(".acc-trigger").on("click", function () {
        $(this).next().slideToggle(300);
        $(this).toggleClass("is-open", 300);
      });
    });  
  }
}